import Api from 'libs/api/index';

class ServerIPS extends Api {
  constructor() {
    super('server_ips');
  }
}

export default ServerIPS;
